import _axios from '../util/axios/AxiosConfig'

export function getAuthorizeLink () {
  return _axios({
    url: '/api/OAuth2/GetAuthorizeLink',
    method: 'get'
  })
}

export function login(code){
  return _axios({
    url: `/api/OAuth2/Login?code=${code}`,
    method: 'get'
  })
}

export function getSignNature(nonceStr,timestamp,url){
  return _axios({
    url: `/api/OAuth2/GetSignNature?noncestr=${nonceStr}&timeStamp=${timestamp}&url=${window.encodeURIComponent(url)}`,
    method: 'get'
  })
}

export function erpLogin(acc,pwd){
  return _axios({
    url: `/api/OAuth2/erplogin?acc=${acc}&pwd=${pwd}`,
    method: 'get'
  })
}